import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React from "react";

export default function CommissionLevelFormRow({
  item,
  index,
  handleCommissionLevelForm,
  commissionLevelValidation,
  removeCommissionLevelFormData,
  disabled,
}) {
  const commissionLevelFormRow = React.useMemo(
    () => (
      <Stack
        sx={{ my: 2 }}
        key={index}
        direction={"row"}
        divider={<Divider orientation="vertical" flexItem variant="middle" />}
        spacing={5}
      >
        <Box sx={{ flex: 3, display: "flex", justifyContent: "center" }}>
          <TextField
            disabled={disabled}
            error={!!commissionLevelValidation[index]?.amountErr}
            helperText={commissionLevelValidation[index]?.amountErr}
            sx={{ maxWidth: 380, minWidth: 100 }}
            value={item.amount}
            type="number"
            id="outlined-basic"
            label="銷售額"
            variant="outlined"
            onChange={(event) =>
              handleCommissionLevelForm(index, {
                amount: Math.abs(event.target.value),
              })
            }
            InputProps={{
              inputProps: {
                min: 0,
              },
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
          />
        </Box>
        <Box sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
          <TextField
            disabled={disabled}
            error={!!commissionLevelValidation[index]?.percentageErr}
            helperText={commissionLevelValidation[index]?.percentageErr}
            sx={{ maxWidth: 180, minWidth: 100 }}
            value={item.percentage}
            type="number"
            id="outlined-basic"
            label="百份比"
            variant="outlined"
            onChange={(event) => {
              handleCommissionLevelForm(index, {
                percentage: event.target.value,
              });
            }}
            InputProps={{
              inputProps: {
                min: 0,
              },
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </Box>
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton
              color="error"
              onClick={() => removeCommissionLevelFormData(index)}
            >
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    ),
    [item, index, removeCommissionLevelFormData]
  );
  return commissionLevelFormRow;
}
